import { Component, OnInit } from "@angular/core";
import { ProgressSpinnerMode } from "@angular/material/progress-spinner";

@Component({
  selector: "app-progress-spinner",
  templateUrl: "./progress-spinner.component.html",
  styleUrls: ["./progress-spinner.component.scss"],
})
export class ProgressSpinnerComponent implements OnInit {
  progressSpinnerStroke = 5;
  progressSpinnerMode: ProgressSpinnerMode = "indeterminate";
  constructor() {}

  ngOnInit(): void {}
}
